import ClockSvg from '@/assets/svgs/clock.svg';
import JobTypeSvg from '@/assets/svgs/job-type.svg';
import CanvassersIconSvg from '@/assets/svgs/main/canvassers.svg';
import IdentitySvg from '@/assets/svgs/main/identity.svg';
import StatusSvg from '@/assets/svgs/status.svg';
import ActiveIcon from '@/assets/svgs/statuses/active.svg';
import AwaitingIcon from '@/assets/svgs/statuses/awaiting.svg';
import CompleteIcon from '@/assets/svgs/statuses/complete.svg';
import DeferredIcon from '@/assets/svgs/statuses/deferred.svg';
import PausedIcon from '@/assets/svgs/statuses/paused.svg';
import PendingIcon from '@/assets/svgs/statuses/pending.svg';
import ContactListTypeTag from '@/containers/ContactLists/components/ContactListTypeTag';
import { ContactListType } from '@/containers/ContactLists/types';
import { formatRelativeTime } from '@/shared/utils/formatRelativeTime';

interface ContactListDetailsSectionProps {
  listState?: string;
  uploadBy: string;
  uploadDate: string;
  listType: ContactListType | null;
  identityName: string;
  leadsLoaded: number;
  leadsRemaining: number;
}

const getStateIcon = (state?: string, leadsLoaded?: number, leadsRemaining?: number) => {
  switch (state) {
    case 'ACTIVE':
      return leadsLoaded && leadsLoaded > 0 && leadsRemaining === 0 ? (
        <CompleteIcon className="h-4 w-4" />
      ) : (
        <ActiveIcon className="h-4 w-4" />
      );
    case 'PAUSED':
      return <PausedIcon className="h-4 w-4" />;
    case 'PENDING':
      return <PendingIcon className="h-4 w-4" />;
    case 'AWAITING-CHECK':
      return <AwaitingIcon className="h-4 w-4" />;
    case 'DEFERRED':
      return <DeferredIcon className="h-4 w-4" />;
    default:
      return null;
  }
};

export const ContactListDetailsSection = ({
  listState,
  uploadBy,
  uploadDate,
  listType,
  identityName,
  leadsLoaded,
  leadsRemaining,
}: ContactListDetailsSectionProps) => {
  return (
    <div className="mb-6 grid grid-cols-[auto_1fr_3fr] gap-x-4 gap-y-4">
      {/* Status */}
      <StatusSvg className="h-4 w-4 text-gray-500" />
      <span className="text-sm font-medium text-gray-700 dark:text-gray-500">Status</span>
      <div className="flex items-center gap-2">
        {getStateIcon(listState, leadsLoaded, leadsRemaining)}
        <span className="text-sm text-gray-900 dark:text-gray-300">{listState}</span>
      </div>

      {/* Uploaded by */}
      <CanvassersIconSvg className="h-4 w-4 text-gray-500" />
      <span className="text-sm font-medium text-gray-700 dark:text-gray-500">
        Uploaded by
      </span>
      <span className="text-sm text-gray-900 dark:text-gray-300">{uploadBy}</span>

      {/* Uploaded at */}
      <ClockSvg className="h-4 w-4 text-gray-500" />
      <span className="text-sm font-medium text-gray-700 dark:text-gray-500">
        Uploaded at
      </span>
      <span className="text-sm text-gray-900 dark:text-gray-300">
        {formatRelativeTime(uploadDate)}
      </span>

      {/* Type */}
      <JobTypeSvg className="h-4 w-4 text-gray-500" />
      <span className="text-sm font-medium text-gray-700 dark:text-gray-500">Type</span>
      <div>
        {listType ? (
          <ContactListTypeTag type={listType} />
        ) : (
          <span className="text-sm text-gray-900 dark:text-gray-300">-</span>
        )}
      </div>

      {/* Identity */}
      <IdentitySvg className="h-4 w-4 text-gray-500" />
      <span className="text-sm font-medium text-gray-700 dark:text-gray-500">
        Identity
      </span>
      <span className="text-sm text-gray-900 dark:text-gray-300">{identityName}</span>
    </div>
  );
};
